














































































import Vue from 'vue'

import { Get, Patch, Delete } from '@/api/user'
import { User } from '@/types/user'

export default Vue.extend({
  name: 'EditUser',
  data() {
    return {
      optsRoles: [
        { text: 'Standar user', value: 'user' },
        { text: 'Operator', value: 'operator' },
        { text: 'Admin', value: 'admin' },
        // { text: 'Instrument', value: 'instrument' },
      ],
      user: {} as User,
      passwordVerification: '',
      passwordIsChanged: false,
    }
  },

  methods: {
    async getUser() {
      const id = this.$route.params.id
      this.user = await Get(parseInt(id))
    },

    async patchUser() {
      if (
        this.passwordIsChanged &&
        this.user.password != this.passwordVerification
      ) {
        this.$toast.error('Password verification is incorrect')
        return
      }
      const id = this.$route.params.id
      this.user = await Patch(parseInt(id), this.user)
    },

    async deleteUser() {
      const id = this.$route.params.id
      this.user = await Delete(parseInt(id))
    },
  },

  watch: {
    'user.password': function(newValue: string, oldValue: string) {
      this.passwordIsChanged = oldValue != ''
    },
  },

  async created() {
    await this.getUser()
  },
})
